/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonSharedServiceTimeDropdownQueryResponse,
  GetApiV1PersonSharedServiceTimeDropdown401,
  GetApiV1PersonSharedServiceTimeDropdown500,
} from "../../types/personSharedController/GetApiV1PersonSharedServiceTimeDropdown.ts";

function getGetApiV1PersonSharedServiceTimeDropdownUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/person/shared/service-time-dropdown` as const,
  };
  return res;
}

/**
 * @description Retorna todas as opções do enumerador EServiceTime para uso em componentes de seleção. **(Requer Authorization para autenticação)**
 * @summary Lista de tempo de serviço para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/person/shared/service-time-dropdown}
 */
export async function getApiV1PersonSharedServiceTimeDropdown(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonSharedServiceTimeDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonSharedServiceTimeDropdown401
      | GetApiV1PersonSharedServiceTimeDropdown500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonSharedServiceTimeDropdownUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
